import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { getMaintenanceMessage } from "../lib/maintenanceUtils";

const MaintenancePage = ({ config }) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(interval);
  }, []);
  const message = getMaintenanceMessage(config);

  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      height="100vh"
      justifyContent="center"
      style={{ backgroundColor: "#fafafa" }}
      width="100vw"
    >
      <img
        alt="logo"
        src="/android-chrome-512x512.png"
        style={{ marginBottom: 16 }}
        width={64}
      />
      <Typography
        color="primary"
        style={{ color: "#6C2BDD", fontWeight: 600 }}
        variant="h5"
      >
        Under Maintenance
      </Typography>
      <Typography
        color="textSecondary"
        style={{ marginTop: 12, maxWidth: 320, textAlign: "center" }}
        variant="body1"
      >
        {message}
      </Typography>
    </Box>
  );
};

export default MaintenancePage;
